<template>
    <div class="footer-sponsors">
        <div>
            <div class="sponsors-line">
                <div>
                    <h2>Partenaire de prestige</h2>
                    <div class="sponsors-line__logos">
                        <img src="@/assets/img/WHITE_CREDIT_SUISSE.svg" alt="">
                    </div>
                </div>
            </div>
            <div class="sponsors-line">
                <div>
                    <h2>Grand mecenes</h2>
                    <div class="sponsors-line__logos">
                        <img src="@/assets/img/WHITE_OSRAMISVD.svg" alt="">
                        <img src="@/assets/img/WHITE_LOTERIEROMANDE.svg" alt="">
                        <img src="@/assets/img/WHITE_FONDTIONLEENARDS.svg" alt="">
                        <img src="@/assets/img/WHITE_FONDATIONMINKOFF.svg" alt="">
                        <img src="@/assets/img/WHITE_ALINEFORIEL-DESTEZET.svg" alt="">
                        <img src="@/assets/img/WHITE_PICTET.svg" alt="">
                        <img src="@/assets/img/WHITE_FONDATIONVONTOBEL.svg" alt="">
                    </div>
                </div>
            </div>
            <div class="sponsors-line">
                <div>
                    <h2>Partenaire de saison</h2>
                    <div class="sponsors-line__logos">
                        <img src="@/assets/img/WHITE_SIG.svg" alt="">
                    </div>
                </div>
                <div>
                    <h2>Partenaire de diffusion</h2>
                    <div class="sponsors-line__logos">
                        <img src="@/assets/img/WHITE_RTS.svg" alt="">
                    </div>
                </div>
                <div>
                    <h2>Partenaire institutionnel</h2>
                    <div><img src="@/assets/img/WHITE_JTI.svg" alt=""></div>
                </div>
                <div>
                    <h2>Autorites subventionnantes</h2>
                    <div class="sponsors-line__logos">
                        <img src="@/assets/img/WHITE_GECANTON.svg" alt="">
                        <img src="@/assets/img/WHITE_GEVILLE.svg" alt="">
                        <img src="@/assets/img/WHITE_VD.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
   export default {
       
    }
</script>
<style scoped lang="scss">
    .footer-sponsors {
        padding: 90px 0;
        color: white;
        background-color: black;

        > div {
            max-width: 1400px;
            padding: 20px;
            margin: 0 auto;
        }

        img {
            height: 50px;
            max-height: 50px;
            max-width: 200px;
            margin-right: 50px;
            margin-bottom: 25px;
        }

        @media print {
            display: none;
        }
    }

    .sponsors-line {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-bottom: 35px;

        > div {
            margin-right: 35px;
        }
    }

    .sponsors-line__logos {
        display: flex;
        flex-wrap: wrap;
    }

    h2 {
        font-size: 20px;
        text-align: left;
        margin: 0 0 25px 0;
        font-family: 'gt-eesti-bold';
    }
</style>